import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isEmpty } from 'lodash';
import T from 'components/common/translations/Translate';
import {
  setUserNameOverride,
  setUserPhoneOverride
} from 'components/actions/bookingActions'

class OverrideUserData extends Component {

  state = {
    openEdit: false,
    name: '',
    phone: '',
    phoneError: ''
  }

  componentDidMount() {
    var { userNameOverride, userPhoneOverride } = this.props;
    if (!isEmpty(userNameOverride) && !isEmpty(userPhoneOverride)) {
      this.setState({
        name: this.props.userNameOverride,
        phone: this.props.userPhoneOverride
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    var cond1 = nextProps.userNameOverride !== '' && nextProps.userPhoneOverride !== '';
    var cond2 = this.state.name == '' && this.state.phone == '';

    if (cond1 && cond2) {
      this.setState({ name: nextProps.userNameOverride, phone: nextProps.userPhoneOverride });
    }
  }

  handleClickEdit = (e) => {
    e.preventDefault();
    this.setState({ openEdit: true });
  }

  handleClickCancel = (e) => {
    e.preventDefault();
    this.setState({
      name: this.props.userNameOverride,
      phone: this.props.userPhoneOverride,
      openEdit: false
    })
  }

  handleClickSave = (e) => {
    e.preventDefault();
    var phoneNumber = this.state.phone;
    var areaCode = phoneNumber.slice(0, 3);
    var error = '';
    if (areaCode == '+48') {
      if (phoneNumber.length != 12) {
        error = 'Wymagana długość numeru telefonu 12';
      }
    }

    if (areaCode == '+47') {
      if (phoneNumber.length != 11) {
        error = 'Wymagana długość numeru telefonu 11';
      }
    }

    if (areaCode != '+48' && areaCode != '+47') {
      if (phoneNumber.length < 11 || phoneNumber.length > 14) {
        error = 'Niepoprawna długość numeru';
      }
    }

    if (isEmpty(error)) {
      this.setState({ phoneError: '', openEdit: false });
      this.props.setUserNameOverride(this.state.name);
      this.props.setUserPhoneOverride(this.state.phone);
    } else {
      this.setState({ phoneError: error })
    }
  }

  handleChangeName = (e) => {
    var value = e.target.value;
    this.setState({ name: value });
  }

  handleChangePhone = (e) => {
    var value = e.target.value;
    var newPhoneNumer = '';
    newPhoneNumer = value.slice(1).replace(/\D/g, '');
    if (value.slice(0, 1) == '+') {
      newPhoneNumer = '+' + newPhoneNumer;
    }
    this.setState({ phone: newPhoneNumer });
  }

  render() {
    return (
      <Fragment>
        <p><T>content.bookingStep4.summary.passengerData</T></p>
        <div>
          {!this.state.openEdit &&
            <div style={{ display: 'inline-block' }}>
              <p>{this.state.name}</p>
              <p>{this.state.phone}</p>
            </div>
          }

          {!this.state.openEdit &&
            <div className='override-button-container' style={{ display: 'inline-block' }}>
              <button
                className='button button--edit button--medium'
                onClick={this.handleClickEdit}
                title='Zmień'>
                <FontAwesomeIcon
                  icon={['fas', 'pencil-alt']}
                  size="xs"
                />
              </button>
            </div>
          }

          {this.state.openEdit &&
            <div>
              <input type="text" onChange={this.handleChangeName} value={this.state.name} />
              <input type="text" onChange={this.handleChangePhone} value={this.state.phone} />
              {!isEmpty(this.state.phoneError) &&
                <div className="form__error" style={{ marginBottom: '0px' }}>
                  {this.state.phoneError}
                </div>
              }
              <p style={{ margin: '5px 0px 5px 6px', fontSize: '12px', color: 'gray' }}>
                (<T>content.bookingStep4.summary.phoneFormat</T>)
              </p>

              <button
                className='button button--edit button--medium'
                onClick={this.handleClickSave}
                title='Zapisz'>
                <FontAwesomeIcon
                  icon={['fas', 'check']}
                  size="xs"
                />
              </button>
              <button
                style={{ marginLeft: '20px' }}
                className='button button--edit button--medium'
                onClick={this.handleClickCancel}
                title='Anuluj'>
                <FontAwesomeIcon
                  icon={['fas', 'ban']}
                  size="xs"
                />
              </button>
            </div>
          }
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale,
    userNameOverride: state.booking.userNameOverride,
    userPhoneOverride: state.booking.userPhoneOverride
  };
};

export default connect(mapStateToProps, { setUserNameOverride, setUserPhoneOverride })(OverrideUserData);


